import { isLocal } from '../localId/localId';
import {
  ADD_LOCAL_LABOR_CLASS,
  API_CREATE_LABOR_CLASS,
  API_LOAD_LABOR_CLASSES,
  API_REMOVE_LABOR_CLASS,
  API_UPDATE_LABOR_CLASS,
  REMOVE_LOCAL_LABOR_CLASS
} from './laborClasses.reducer';

export const load = () => ({ resourceAction: API_LOAD_LABOR_CLASSES });
export const save = resource => ((isLocal(resource.id)) ? {
  resourceAction: API_CREATE_LABOR_CLASS,
  resource
} : { resourceAction: API_UPDATE_LABOR_CLASS, resource });
export const add = () => ({ type: ADD_LOCAL_LABOR_CLASS });
export const remove = id => ((isLocal(id)) ? { type: REMOVE_LOCAL_LABOR_CLASS, id } : {
  resourceAction: API_REMOVE_LABOR_CLASS,
  id,
});



// WEBPACK FOOTER //
// ./src/reducers/laborClasses/laborClasses.actions.js